export function SAVE_FILTERS(state, [progress, search, selected_areas, selected_groups, selected_tags]){
    state.progress = progress
    state.search = search
    state.selected_areas = selected_areas
    state.selected_groups = selected_groups
    state.selected_tags = selected_tags
}

export function SAVE_PRESENTIAL_STATUS(state, [presential_status]){
    state.presential_status = presential_status
}

export function SAVE_PRESENTIAL_IS_ONLINE(state, [presential_is_online]){
    state.presential_is_online = presential_is_online
}

export function SAVE_PROGRESS(state, progress){
    state.progress = progress
}
export function SAVE_FILTER_AREA(state, selected_areas){
    state.selected_areas = selected_areas
}

export function SAVE_LOADING(state, loading){
    state.loading = loading
}